@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-input-text'"
        [label]="label() | translate"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="(control().errors && (control().dirty || control().touched)) || false">
    </form-label>
}

<p-iconField iconPosition="right">
    @if (tooltipErrorMessages().length) {
        <p-inputIcon styleClass="fa-sharp fa-solid fa-circle-exclamation" />
    }
    <ng-container [ngTemplateOutlet]="inputTextTemplate"></ng-container>
</p-iconField>

<ng-template #inputTextTemplate>
    <input
        pInputText
        [upperCaseInput]="shouldBeUpperCase()"
        [id]="id() + '-input-text'"
        [pTooltip]="tooltipErrorMessages().join('. ') | translate"
        [tooltipPosition]="tooltipErrorPlacement()"
        [tooltipStyleClass]="'input-error-tooltip'"
        [escape]="false"
        [type]="type()"
        [placeholder]="placeholder() | translate"
        [formControl]="control()"
        [invalid]="control().errors && (control().dirty || control().touched)"
        [class.glue-left]="glueLeft()"
        [class.glue-right]="glueRight()"
        [fluid]="true"
        [attr.disabled]="control().disabled || null"
        [pSize]="size()"
        [type]="type()"
        (input)="inputChange()"
        (blur)="inputBlur()" />
</ng-template>

@if (!useTooltipError() && control().invalid && (control().dirty || control().touched)) {
    @for (error of getErrorKeys(control().errors); track error) {
        <form-error [text]="getErrorMessage(error)"></form-error>
    }
}
